export default {
  case_db: '资料库',
  case_title: '判案书标题',
  ap_remarks: '备注',
  srch_doctitle: '文件标题',
  srch_type: '类别',
  itemperpage: '每页显示结果',
}